import type { VerseEnv } from '@rb/shared/admin-verses';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type EnvSchema = 'dev' | 'staging' | 'production';

/** Map VerseEnv ('prod') → EnvSchema ('production') for R2 path lookups. */
export function envSchemaForVerseEnv(env: VerseEnv): EnvSchema {
  return env === 'prod' ? 'production' : env;
}

interface Props {
  value: EnvSchema;
  onChange: (v: EnvSchema) => void;
}

export function EnvSelector({ value, onChange }: Props) {
  return (
    <div className="mb-3 flex flex-col gap-1">
      <Label htmlFor="md-env-selector" className="text-xs text-muted-foreground">
        Env
      </Label>
      <Select value={value} onValueChange={(v) => onChange(v as EnvSchema)}>
        <SelectTrigger id="md-env-selector" size="sm" className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="dev">dev</SelectItem>
          <SelectItem value="staging">staging</SelectItem>
          <SelectItem value="production">production ⚠️</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
